export enum MIGRATION_TYPE_ENUM {
  Applied = 1,
  Pending = 2,
}
